import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative min-h-[600px] md:h-[720px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20streetwear%20fashion%20collection%20flat%20lay%20on%20a%20clean%20bright%20background%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20artistically%20fresh%20daylight%20modern%20editorial%20photography%20high%20energy%20composition&width=1920&height=1080&seq=hero-bg-01&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20 md:py-0">
        <div className="max-w-4xl mx-auto text-center">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400" />
            <span className="text-accent-300 text-xs font-semibold tracking-widest uppercase">
              {t('hero_eyebrow')}
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            CSSBuy <span className="text-primary-400">Spreadsheet</span>:<br className="hidden md:block" />
            <span className="text-2xl md:text-4xl lg:text-5xl"> {t('hero_title').split(':')[1]}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero_subtitle')}
          </p>

          {/* Search Bar */}
          <div className="max-w-xl mx-auto mb-8">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 w-5 h-5 flex items-center justify-center" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t('search_placeholder')}
                className="w-full pl-12 pr-4 py-3.5 rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400/50 transition-all"
              />
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap text-sm md:text-base"
            >
              {t('hero_cta_primary')}
            </a>
            <a
              href="/cssbuy-spreadsheet/"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 font-semibold rounded-lg hover:bg-white/20 transition-all whitespace-nowrap text-sm md:text-base"
            >
              {t('hero_cta_secondary')}
            </a>
          </div>

          {/* Trust Badge */}
          <div className="flex items-center justify-center gap-4 text-white/60 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center" />
              {t('independent_notice')}
            </span>
            <span className="hidden sm:block">•</span>
            <span className="hidden sm:block">{t('hero_trust')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}